import {panelOptions} from "../../panel/consts.jsx";

export const dateTimeFilterEnabledPanels = {
    [panelOptions.happyHours]: true
};

export const isDateTimeFilterEnabled = panel => {
    return dateTimeFilterEnabledPanels[panel] === true;
};

export const dateTimeFilterTitles = {
    [panelOptions.happyHours]: "מתי לשלוח?"
};

// Default title
export const DEFAULT_DATE_TIME_FILTER_TITLE = "מתי לשלוח?";

// Labels
export const DATE_TIME_LABELS = {
    eventDate: "מתי האירוע?",
    eventDatePlaceholder: "בחירת תאריך",
    maxTime: "עד מתי תרצו שההזמנה תגיע",
    maxTimePlaceholder: "שעת מקסימום",
    maxTimeTooltip:
        "לכל ספק יש חלון שילוח שונה, ולכן ציון שעת מקסימום יעזור לנו לוודא שההזמנה תגיע עד השעה שאתם צריכים",
    tomorrowButton: "משלוח למחר",
    searchButton: "חיפוש",
    clearButton: "נקה"
};

// Constants
export const DELIVERY_PROVIDER_DEADLINE_HOUR = 18; // Well-B delivery providers close from 18:00
export const MINIMUM_ORDER_NOTICE_HOURS = 3; // Minimum 3 hours notice

// Time picker constants
export const DEFAULT_MINUTE_STEP = 15; // Default 15-minute intervals
export const SECONDS_PER_MINUTE = 60; // Seconds in a minute
export const MIN_TIME_HOUR = 7; // Minimum selectable hour (7:00)
export const MAX_TIME_HOUR = 23; // Maximum selectable hour
export const MAX_TIME_MINUTE = 45; // Maximum selectable minute at hour 23 (23:45)
export const MIN_TIME_STRING = "07:00"; // Minimum time string
export const MAX_TIME_STRING = "23:45"; // Maximum time string
export const FIRST_DISABLED_MINUTE_AT_23 = 46; // First disabled minute at hour 23
export const LAST_MINUTE = 59; // Last minute of the hour
export const DISABLED_MINUTES_COUNT_AT_23 = LAST_MINUTE - MAX_TIME_MINUTE; // 14 minutes (46-59)
